import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { HeroBanner } from "@sentara-health/optimahealth_web";
import HomeTiles from "./HomeTiles";
import { Brands, useBranding, useGlobalState } from "providers";
import { DeviceTypes } from "utils/constants/Constants";

export const Dashboard = () => {
  const { deviceType } = useGlobalState();
  const { t } = useTranslation();
  const isMobile = deviceType === DeviceTypes.MOBILE;
  const { brandConfig } = useBranding();
  const heroImagePath = brandConfig.bannerMobileImage;
  const title = t("dashboard.label.title");
  const description = t("dashboard.label.bannerDesc");
  const buttonText = t("dashboard.label.learnMore");
  const buttonLink = brandConfig.link.dashboardLearnMoreLink;
  const backgroundColor = !isMobile
    ? brandConfig.bannerBackgroundColor
    : undefined;
  const backgroundImagePath = !isMobile ? brandConfig.bannerImage : undefined;
  const backgroundSize = !isMobile
    ? brandConfig.bannerBackgroundSize
    : undefined;

  useEffect(() => {
    document.title = t("pageTitleADA.dashboard");
  }, []);

  return (
    <div>
      <div className="dashboard">
        <HeroBanner
          dataTestId={"imgEmployerDashboard"}
          bannerImagePath={heroImagePath}
          backgroundImage={backgroundImagePath}
          bannerAltText={t("dashboard.label.bannerImgAltText")}
          className="img-fluid w-100 border-radius10"
          title={title}
          description={description}
          descriptionLevel={3}
          descriptionVariant={"body"}
          buttonText={buttonText}
          buttonLink={buttonLink}
          headingVariant={brandConfig.brandName === Brands.AVMED ? "semiBold" : "medium"}
          headingLevel={brandConfig.brandName === Brands.AVMED ? 2 : 1}
          learnMoreButton={true}
          backgroundColor={backgroundColor}
          backgroundSize={backgroundSize}
        />
      </div>
      <div className="grid-cont d-flex">
        <div className="left-border-white" aria-hidden="true"></div>
        <HomeTiles />
        <div className="bottom-border-white" aria-hidden="true"></div>
      </div>
    </div>
  );
};

export default Dashboard;
